export const getIssueLifecycleConfig = (isClosed) => isClosed
   ? {
      action: 'reopen',
      menuLabel: 'Reopen issue',
      title: 'Reopen this issue?',
      confirmLabel: 'Reopen issue',
      busyLabel: 'Reopening…',
      description: 'This Issue will be reopened.'
   }
   : {
      action: 'close',
      menuLabel: 'Close issue',
      title: 'Mark this issue as resolved?',
      confirmLabel: 'Close issue',
      busyLabel: 'Closing…',
      description: 'This Issue will be marked as resolved and closed.'
   };

export const buildIssueLifecyclePayload = (issue, utcNow) => ({
   idIssue: issue && issue.id,
   noIssue: issue && issue.noIssue,
   utcNow
});
